document.addEventListener("DOMContentLoaded", () => {
  initScrollAnimations(false);

  // Support for theme editor
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    const allAnimationClasses =
      ".animate-on-scroll, .animate-from-left, .animate-from-right, .animate-zoom-in, .animate-from-bottom";

    // Make everything visible inside editor
    document.querySelectorAll(allAnimationClasses)
      .forEach((el) => el.classList.add("animate-visible"));

    // When section is added
    document.addEventListener("shopify:section:load", () => {
      initScrollAnimations(true);

      document.querySelectorAll(allAnimationClasses)
        .forEach((el) => el.classList.add("animate-visible"));
    });

    // When selecting or deselecting block
    document.addEventListener("shopify:block:select", () => initScrollAnimations(false));
    document.addEventListener("shopify:block:deselect", () => initScrollAnimations(false));
  }
});

function initScrollAnimations(alwaysReplay) {
  const selectors =
    ".animate-on-scroll, .animate-from-left, .animate-from-right, .animate-zoom-in, .animate-from-bottom";

  const sections = document.querySelectorAll(selectors);
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-visible");
          if (!alwaysReplay) obs.unobserve(entry.target);
        } else if (alwaysReplay) {
          entry.target.classList.remove("animate-visible");
        }
      });
    },
    { threshold: 0.15 }
  );

  sections.forEach((sec) => observer.observe(sec));
}
